import styled from 'styled-components';

import variables from '../../../../styles/variables';
import CssClassName from '../../../../utils/generateCssClassName/CssClassName';

export const NoResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MessageBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  width: 72%;
  padding: 20px 10px 10px 10px;
  @media screen and (max-width: 1200px) {
    width: 90%;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
    justify-self: center;
    align-self: center;
    padding: 20px;
  }
`;

export const Box = styled.div`
  margin: 14px 0;
  &.${CssClassName.KIOSK} {
    display: none;
  }
`;

export const Message = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 12px;
  color: ${variables.colorBlackAlt};
  text-align: center;
  max-width: 281px;
  a {
    color: ${variables.colorBlackAlt};
  }
`;

export const MessageTitle = styled.p`
  color: ${variables.colorBlackAlt};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0;
  line-height: 24px;
`;

export const ChatButton = styled.button`
  margin: 0 auto;
  background: none;
  cursor: pointer;
  border: none;
  width: 190px;
  padding: 0;

  &:hover,
  &:focus {
    img {
      border: 1px solid ${variables.colorGreyMedium1};
      transition: border 400ms ease-out;
    }
  }

  img {
    width: 190px;
    height: 83.93px;
    margin: 0 auto;
    border-radius: 10px;
    border: 1px solid transparent;
    transition: border 400ms ease-out;
  }
`;
